<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    label="Базовая мера"
    no-data-text="Мера не найдена"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { RoadmapBaseEventsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompleteBaseEvent',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  props: {
    roadmapId: {
      type: [String, Number],
      required: true,
    },
    directionId: {
      type: [String, Number],
      required: true,
    },
  },
  created() {
    const api = new RoadmapBaseEventsApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(rawProps, config) {
      const props = {
        roadmap_id: this.roadmapId,
        direction_id: this.directionId,
        ...rawProps,
      }

      return this.adapter.getAll(props, config)
    },
  },
}
</script>
